import { useState, useEffect } from "react";
import "./slide.css"
import { Link, withRouter } from 'react-router-dom';
import { red, yellow } from "@material-ui/core/colors";
import Dropdown from 'react-bootstrap/Dropdown';

const ResponsiveSlideMenu = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      // Close menu when switching to desktop view
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape" && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    document.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMenuOpen]);

  return (
    <>
      {/* Toggle Button - Only shown on mobile */}
      {isMobile && (
        <>
        <div className="bg-warning container-nav" > 
            <button
          type="button"
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="hamburger">
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </span>
        </button>
         <div className='text-center mt-3'>
        <Link className="navbar-brand js-scroll-trigger" to="/">
        
        <span style={{fontSize:"30px", fontWeight:1000, color:"black",textShadow: '2px 2px 4px white', fontStyle:"italic"}}><img className="logo w-20 mb-2 " src='https://cash4device.s3.ca-central-1.amazonaws.com/brand_logo/brand_logo.PNG' alt="Log Cabin" />Ca$h<span style={{color:"white",textShadow: `
          -1px -1px 0 #000,  
          1px -1px 0 #000,
          -1px 1px 0 #000,
          1px 1px 0 #000
        `,}}><i>4</i></span><span style={{}}>Device</span></span>
           
        </Link>
        </div>
        <ul className="menu-items container-nav ml-5">
        <div className=''>
            <Link className="nav-lik  px-0 px-lg rounded js-scroll-trigger " to="/Cart">
                <i class="fa fa-archive fa-2x" aria-hidden="true"></i>              
                    <span className="badge badge-dark cart-badge position-relative">
                        {props.items}                
                    </span>
            </Link>
          </div>
          <li>
          {props.isAuthenticated?
            <div className='container-nav1 mr-2 mt-3'>
            <Dropdown className="">
                <Dropdown.Toggle as={props.customToggle} id="dropdown-custom-components">
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item eventKey="1" onClick={props.myAccount}>My Account</Dropdown.Item>
                    <Dropdown.Item eventKey="2" onClick={props.logout} >Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>:     
        <div className='container-nav1 mr-2 mt-3'>
                <Dropdown className="">
                    <Dropdown.Toggle as={props.customToggle} id="dropdown-custom-components">
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item eventKey="1" onClick={props.login}>Login</Dropdown.Item>
                        <Dropdown.Item eventKey="2" onClick={props.register} >SignUp</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown> 
        </div>  }
          </li>
       
          </ul>
        
        </div>
                               
        </>
        
      )}

      {/* Overlay - Only for mobile */}
      {isMobile && isMenuOpen && (
        <div
          className="menu-overlay"
          onClick={() => setIsMenuOpen(false)}
          role="presentation"
        />
      )}

      {/* Menu - Different behavior based on screen size */}
      <div
        className={`responsive-menu bg-warning  border  ${isMobile ? "mobile" : "desktop"} ${
          isMenuOpen ? "open" : ""
        }`}
      >
        
       
        
        
        <ul className="menu-items container-nav">
        <li>
       
        <Link className="navbar-brand js-scroll-trigger ml-2" to="/">
        
        <span style={{fontSize:"30px", fontWeight:1000, color:"black",textShadow: '2px 2px 4px white', fontStyle:"italic"}}><img className="logo w-20 mb-2 " src='https://cash4device.s3.ca-central-1.amazonaws.com/brand_logo/brand_logo.PNG' alt="Log Cabin" />Ca$h<span style={{color:"white",textShadow: `
          -1px -1px 0 #000,  
          1px -1px 0 #000,
          -1px 1px 0 #000,
          1px 1px 0 #000
        `,}}><i>4</i></span><span style={{}}>Device</span></span>
           
        </Link>
       
          </li>
          <li>
            <a href="/WhySellToUs" onClick={() => setIsMenuOpen(false)}>
            <span style={{fontSize:17, fontWeight:700}}>Why Sell to Us</span>
            </a>
          </li>
          <li>
            <a href="/SellBulk" onClick={() => setIsMenuOpen(false)}>
            <span style={{fontSize:17, fontWeight:700}}>Sell In Bulk</span>
            </a>
          </li>
          <li>
            <a href="/SellAdevice" onClick={() => setIsMenuOpen(false)}>
            <span style={{fontSize:17, fontWeight:700}}>Sell A Device</span>
            </a>
          </li>
          <li>
            <a href="/Support" onClick={() => setIsMenuOpen(false)}>
            <span style={{fontSize:17, fontWeight:700}}>Support</span>
            </a>
          </li>
          <li>
            <div className='ccontainer-nav1'>
            <Link className="nav-lik  px-0 px-lg rounded js-scroll-trigger " to="/Cart">
                <i class="fa fa-archive fa-2x" aria-hidden="true"></i>              
                    <span className="badge badge-dark cart-badge position-relative">
                        {props.items}                
                    </span>
            </Link>
            </div>
          </li>
          <li>
          {props.isAuthenticated?
            <div className='container-nav1 mr-2'>
            <Dropdown className="">
                <Dropdown.Toggle as={props.customToggle} id="dropdown-custom-components">
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item eventKey="1" onClick={props.myAccount}>My Account</Dropdown.Item>
                    <Dropdown.Item eventKey="2" onClick={props.logout} >Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>:     
        <div className='container-nav1 mr-2'>
                <Dropdown className="">
                    <Dropdown.Toggle as={props.customToggle} id="dropdown-custom-components">
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item eventKey="1" onClick={props.login}>Login</Dropdown.Item>
                        <Dropdown.Item eventKey="2" onClick={props.register} >SignUp</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown> 
        </div>  }
          </li>
        </ul>
        
      
        
      </div>
    </>
  );
};

export default ResponsiveSlideMenu;
